import { Form } from 'antd';
import { useWorkstations } from '@/hooks/v1';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useResolution886Report } from '@/context/Resolution886Report';

const { useFormInstance, useWatch } = Form;

interface WorkstationProps {
	fieldName?: string | string[];
}

export function useWorkstation({ fieldName }: WorkstationProps) {
	const form = useFormInstance();
	const { newReview, firstReview } = useResolution886Report();
	const { organization, company } = useApplicationContext();

	const field = Array.isArray(fieldName) ? fieldName[0] : null;

	const lineId = useWatch(field ? [field, 'line_id'] : 'line_id', form);
	const workstationId = useWatch(field ? [field, 'workstation_id'] : 'workstation_id', form);

	function handleSelectWorkstation(id: string): void {
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], id);
	}

	function handleClearWorkstation(): void {
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], undefined);
	}

	const {
		isLoading,
		isFetching,
		data: workstations = [],
		isError
	} = useWorkstations({
		organization_id: organization?.id,
		company_id: company?.id,
		line_id: lineId
	});

	const items = workstations.map((workstation) => ({
		label: workstation.name,
		value: workstation.id
	}));

	const isDisabled = !lineId || isLoading || isFetching || newReview || !firstReview;

	return {
		items,
		isLoading,
		isFetching,
		isError,
		isDisabled,
		workstationId,
		handleSelectWorkstation,
		handleClearWorkstation
	};
}
